let AdminStarterCampaignsIndexTourSteps  = {
  tourSteps: function() {
    return [
        {
          content: 'The starter workflows page lists the starter workflows.',
          target: '.help_icon_smaller',
          placement: 'bottom',
          disableBeacon: true
        },
        {
          content: 'Use this button to create a new starter workflow.',
          target: '.new_campaign_btn',
          placement: 'bottom',
          disableBeacon: true
        },
        {
          content: "This is the name of the starter workflow.",
          target: '.campaign_name',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the category of the starter workflow.",
          target: '.campaign_category',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the author of the starter workflow.",
          target: '.campaign_author',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the description of the starter workflow.",
          target: '.campaign_description',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the current status of starter workflow. A starter workflow is in draft mode until you publish it. Published starter workflows will be visible to users to copy.",
          target: '.campaign_status',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of steps in a starter workflow.",
          target: '.campaign_steps',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "Click here to edit a starter workflow.",
          target: '.campaign_edit',
          placement: 'top',
          disableBeacon: true
        }
    ];
  }
};
export default AdminStarterCampaignsIndexTourSteps;
